/**
 * Labstep
 *
 * @module screens/ResourceItem/Show
 * @desc ResourceItem Show Screen
 */

import { DocumentHead } from 'labstep-web/core/DocumentHead';
import { ReadOnMountHOC } from 'labstep-web/hoc/ReadOnMount';
import { ResourceItem } from 'labstep-web/models/resource-item.model';
import MasterShow from 'labstep-web/screens/Master/Show';
import { Center } from 'labstep-web/screens/ResourceItem/Show/Center';
import { ScreensResourceItemShowRight as Right } from 'labstep-web/screens/ResourceItem/Show/Right';
import type React from 'react';
import type {
  IResourceItemShowScreenContainerProps,
  IResourceItemShowScreenProps,
} from './types';

export const ResourceItemShowScreen: React.FC<
  IResourceItemShowScreenProps
> = ({ resourceItem }) => (
  <>
    <DocumentHead title={resourceItem.name || ''} />
    <MasterShow
      entity={resourceItem}
      center={<Center resourceItem={resourceItem} />}
      right={<Right resourceItem={resourceItem} />}
    />
  </>
);

export const ResourceItemShowScreenContainer: React.FC<
  IResourceItemShowScreenContainerProps
> = ({ match }: any) => (
  <ReadOnMountHOC
    type="entities"
    entityName={ResourceItem.entityName}
    params={{
      get_single: 1,
      id: match.params.id,
    }}
    loading={{ loader: 'show', cached: true }}
    children={({ entity }) => (
      <ResourceItemShowScreen resourceItem={entity} />
    )}
  />
);
